/* FullTextComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./FullTextRenderer");

/**
 * Modal that shows the complete text of a result popup (violation tree or config lines) so long
 * values can be read and copied in full. Displayed via userFeedback.displayCustom().
 */
class FullTextComponent extends EventEmitter {
    constructor(text, title) {
        super();
        this._text = text || "";
        this._title = title || "";
        this._context = undefined;
        this._shutdownProm = undefined;
        this._renderer = new Renderer(this);
    }

    get renderer() {
        return this.getRenderer();
    }

    get rootElement() {
        return this._renderer && this._renderer.getRootElement();
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _shutdown() {
        this.emit("Shutdown");
        this.removeAllListeners();
        return Promise.resolve(this._renderer.shutdown())
            .then(() => {
                this._renderer = null;
                this._text = null;
                this._shutdownProm = null;
            })
            .catch((error) => {
                console.log(`${this.constructor.name}: error in shutdown`);
                console.error(error);
            });
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        if (this._shutdownProm === null) {
            return Promise.resolve();
        }
        this._shutdownProm = this._shutdownProm || this._shutdown();
        return this._shutdownProm;
    }

    closePopUp() {
        this._context.resolve();
    }

    /*******************************************/
    /* END PUBLIC COMPONENT MODEL METHODS      */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    get text() {
        return this.getText();
    }

    getText() {
        return this._text;
    }

    get title() {
        return this.getTitle();
    }

    getTitle() {
        return this._title;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = FullTextComponent;
